import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  isDevMode,
  LOCALE_ID,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { CookieService } from 'ngx-cookie-service';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { AuthModule } from './pages/auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { ROOT_EFFECTS, ROOT_REDUCERS } from './core/state/app.state';
import { ToastService, AngularToastifyModule } from 'angular-toastify';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SafePipe } from './core/pipes/safe.pipe';
import { ParseJsonPipe } from './core/pipes/parse-json.pipe';
import { authInterceptorProviders } from './core/interceptors/auth.interceptor';
import { errorInterceptorProviders } from './core/interceptors/http-error.interceptor';
import { InactivityService } from './shared/services/inactivity.service';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { networkInterceptorProviders } from './core/interceptors/network.interceptor';

registerLocaleData(localeEs);
const TOAST_TOP_RIGHT_POSITION_CLASS = 'custom-toastr-top';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AngularToastifyModule,
    NgbModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OverlayModule,
    SharedModule,
    HttpClientModule,
    NgxSpinnerModule,
    CollapseModule.forRoot(),
    ProgressbarModule.forRoot(),
    ModalModule.forRoot(),
    ToastrModule.forRoot({
      progressBar: true,
      positionClass: TOAST_TOP_RIGHT_POSITION_CLASS,
      enableHtml: true,
      preventDuplicates: true,
    }),
    BsDropdownModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    // for HttpClient use:
    LoadingBarHttpClientModule,
    // for Router use:
    LoadingBarRouterModule,
    // for Core use:
    LoadingBarModule,
    // for Redux:
    StoreModule.forRoot(ROOT_REDUCERS),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    EffectsModule.forRoot(ROOT_EFFECTS),
  ],
  providers: [
    CookieService,
    ToastService,
    ...networkInterceptorProviders,
    ...authInterceptorProviders,
    ...errorInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'es-ES' },
    InactivityService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
